import ResourceWrapper from './ResourceWrapper';

export default ResourceWrapper;
